const formatLinkedinMention = ({ blocks = [], entityMap = {} }) => {
  if (!blocks.length) return "";

  const originalMessages = blocks.map(block => block.text);
  const replacements = blocks.map(block => block.entityRanges);

  const messages = originalMessages.map((message, index) => (
    replacements[index].sort((a, b) => b.offset - a.offset) // Desc
      .reduce((message, { key, offset, length }) => {
        const startIndex = offset;
        const endIndex = startIndex + length;

        const { data: { name, urn } } = entityMap[key];
        if (!urn) return message;

        const before = message.slice(0, startIndex);
        const after = message.slice(endIndex);
        const replaceValue = `@[${name}](${urn.replace(/-/g, "_")})`; // @[Josué Santamaria](urn:li:person:DpId_d_Poi)

        return `${before}${replaceValue}${after}`;
      }, message)
  ));
  return messages.join("\n");
};

export default formatLinkedinMention;
